import React, { useEffect, useState } from 'react';
import { TextField, Typography, Box, Link } from '@mui/material';
import { Link as LinkIcon } from '@mui/icons-material';
import ErrorWrapper from '@component/ErrorWrapper';
import { SmartFormStates } from './SmartForm';
import { syncValidatorResults } from "@component/smartForm/validatorUtils"

const SmartLinkInput = ({
  field,
  label,
  value,
  onChange,
  isEdit,
  sx = {},
  renderView,
  icon: IconComponent = LinkIcon,
  iconProps = { fontSize: "small", sx: { mr: 1 } },
  emptyLinkValue = '-',
  editable = true,
  validator,
  validatorResults,
  setValidatorResults,
  formState,
  ...props
}) => {

  const [showError, setShowError] = useState(false)
  const [validatorResult, setValidatorResult] = useState("");

  useEffect(() => {
    setShowError(formState === SmartFormStates.SAVING);
  }, [formState]);

  useEffect(() => {
    if (validator) {
      const validatorResult = validator(value);
      syncValidatorResults(validatorResults, setValidatorResults, !validatorResult, label)
      setValidatorResult(validatorResult)
    }

  }, [value, validator])
  
  const handleChange = (e) => {
    onChange(field, e.target.value);
  };

  const formatUrl = (url) => {
    if (!url) return url;
    // Add https:// if no protocol exists
    if (!/^https?:\/\//i.test(url)) {
      return `https://${url}`;
    }
    return url;
  };

  const handleClick = (e) => {
    if (!value) {
      e.preventDefault();
      return;
    }

    const formattedUrl = formatUrl(value);
    if (formattedUrl !== value) {
      e.preventDefault();
      window.open(formattedUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <Box sx={sx}>
      {!isEdit || !editable ? (
        renderView ? (
          renderView(value)
        ) : (
          <>
            {label && <Typography variant="h6">{label}</Typography>}
            <Typography variant="body1" sx={{ mt: 0.5 }}>
              {value ? (
                <>
                  <Link
                    href={formatUrl(value)}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={handleClick}
                    sx={{ display: 'flex', alignItems: 'center' }}
                  >
                    <IconComponent {...iconProps} />
                    {value}
                  </Link>
                </>
              ) : (emptyLinkValue)}
            </Typography>
          </>
        )
      ) : (
     <ErrorWrapper message={validatorResult} showMessage={showError}>
        <TextField
          label={label}
          value={value || ''}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          placeholder="example.com"
          InputProps={{
            startAdornment: <IconComponent {...iconProps} />
          }}
          {...props}
        />
      </ErrorWrapper>
      )}
    </Box>
  );
};

export default SmartLinkInput;